import { ISwAppAuthorizationApi } from "../../interfaces-and-types";

type TMerchantAccountUrls = {
  [key in keyof ISwAppAuthorizationApi]: string;
};

const rootUrl = "/authorization/transfers";

export const authorizationUrls: TMerchantAccountUrls = {
  validateLoginDetails: `${rootUrl}/validate-login-details`,
  createTransferPin: `${rootUrl}/create-transfer-pin`,
  ChangeTransferPin: `${rootUrl}/change-transfer-pin`,
};
